export const ModalType = {
    Create: 0,
    Edit: 1,
    View: 2,
};

export const MODAL_Z_INDEX = {
    base: 9999,
    basePopup: 10000,
    aboveModal: 10001,
    aboveModalPopup: 10002,
};
